export const formatIDR = (n) => {
  const v = Math.round(Number(n) || 0);
  return "Rp " + v.toLocaleString("id-ID");
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "-";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
};

export const formatDateTime = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "-";
  return `${formatDate(iso)} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

export const dateInputValue = (iso) => {
  if (!iso) return "";
  return iso.slice(0, 10);
};

// Booking statuses -> Indonesian labels + color classes
export const BOOKING_STATUS = {
  inquiry: { label: "Inquiry", cls: "bg-neutral-100 text-neutral-700 border-neutral-300" },
  draft: { label: "Draft", cls: "bg-neutral-100 text-neutral-700 border-neutral-300" },
  quotation_sent: { label: "Quotation Terkirim", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  waiting_approval: { label: "Menunggu Persetujuan", cls: "bg-yellow-50 text-yellow-700 border-yellow-200" },
  approved: { label: "Disetujui", cls: "bg-green-50 text-green-700 border-green-200" },
  deposit_pending: { label: "Menunggu DP", cls: "bg-yellow-50 text-yellow-700 border-yellow-200" },
  confirmed: { label: "Terkonfirmasi", cls: "bg-green-50 text-green-700 border-green-200" },
  reserved: { label: "Direservasi", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  preparing: { label: "Sedang Disiapkan", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  ready: { label: "Siap Ambil", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  checked_out: { label: "Sedang Disewa", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  partially_returned: { label: "Sebagian Dikembalikan", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  returned: { label: "Dikembalikan", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  under_inspection: { label: "Dalam Pemeriksaan", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  completed: { label: "Selesai", cls: "bg-neutral-100 text-neutral-700 border-neutral-300" },
  cancelled: { label: "Dibatalkan", cls: "bg-red-50 text-red-700 border-red-200" },
};

export const INVOICE_STATUS = {
  draft: { label: "Draft", cls: "bg-neutral-100 text-neutral-700 border-neutral-300" },
  issued: { label: "Diterbitkan", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  partial: { label: "Sebagian Dibayar", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  paid: { label: "Lunas", cls: "bg-green-50 text-green-700 border-green-200" },
  overdue: { label: "Jatuh Tempo", cls: "bg-red-50 text-red-700 border-red-200" },
  cancelled: { label: "Dibatalkan", cls: "bg-neutral-100 text-neutral-700 border-neutral-300" },
  refunded: { label: "Refund", cls: "bg-purple-50 text-purple-700 border-purple-200" },
};

export const QTN_STATUS = {
  draft: { label: "Draft", cls: "bg-neutral-100 text-neutral-700 border-neutral-300" },
  sent: { label: "Terkirim", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  viewed: { label: "Dilihat", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  revision_requested: { label: "Revisi Diminta", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  approved: { label: "Disetujui", cls: "bg-green-50 text-green-700 border-green-200" },
  rejected: { label: "Ditolak", cls: "bg-red-50 text-red-700 border-red-200" },
  expired: { label: "Kedaluwarsa", cls: "bg-neutral-100 text-neutral-700 border-neutral-300" },
  converted: { label: "Menjadi Booking", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  cancelled: { label: "Dibatalkan", cls: "bg-neutral-100 text-neutral-700 border-neutral-300" },
};

export const ASSET_STATUS = {
  tersedia: { label: "Tersedia", cls: "bg-green-50 text-green-700 border-green-200" },
  direservasi: { label: "Direservasi", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  sedang_disiapkan: { label: "Sedang Disiapkan", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  sedang_disewa: { label: "Sedang Disewa", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  terlambat_kembali: { label: "Terlambat Kembali", cls: "bg-red-50 text-red-700 border-red-200" },
  dalam_pemeriksaan: { label: "Dalam Pemeriksaan", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  dalam_perawatan: { label: "Dalam Perawatan", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  rusak: { label: "Rusak", cls: "bg-red-50 text-red-700 border-red-200" },
  hilang: { label: "Hilang", cls: "bg-red-50 text-red-700 border-red-200" },
  tidak_aktif: { label: "Tidak Aktif", cls: "bg-neutral-100 text-neutral-700 border-neutral-300" },
};

export const CUSTOMER_TYPE = {
  individual: "Individu",
  company: "Perusahaan",
  production_house: "Production House",
  agency: "Agensi",
  freelancer: "Freelancer",
  student: "Mahasiswa",
  other: "Lainnya",
};

export const ROLE_LABEL = {
  super_admin: "Super Admin",
  sales: "Sales",
  booking_admin: "Booking Admin",
  warehouse: "Warehouse",
  finance: "Finance",
};
